import { connect } from 'react-redux';
import { selectFeature, SURVEYS_RESPONSE_EXPORT } from 'next/entities/features';
import {
  selectResponse,
  read as fetchSurveyResponses,
} from 'next/entities/surveys';
import SurveyResponses from './SurveyResponses';

const mapStateToProps = (state, { flowId: id }) => ({
  surveys: selectResponse(state, id),
  hasSurveysExport: selectFeature(state, SURVEYS_RESPONSE_EXPORT),
});
const mapDispatchToProps = (dispatch, { flowId: id, start, end }) => ({
  onLoad: () =>
    dispatch(
      fetchSurveyResponses({ id, start, end, contentType: 'EXPERIENCE' })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyResponses);
